import { mapActionsFromConfigurations } from '../../helpers/action';
import { configurations } from './configurations';
import { apiAction as health } from './configurations/health';

export const apiActions = {
  systemStatus: {
    health
  }
}

const actions = mapActionsFromConfigurations('systemStatus')(configurations);

export * from './configurations/endpoints';

export default actions;


// WEBPACK FOOTER //
// ./src/state/modules/system-status/actions.js